import { integrationList } from '@repo/common/constants/integration/integrations';
import type { IIntegration } from '../../../api';
import { useIntegrationList } from '../../../api';

export const useQueryableIntegrationOptions = () => {
	const integrations = useIntegrationList({});

	return (
		(integrations?.data?.results ?? [])
			.filter((integration) =>
				integrationList.find(
					(localIntegration) =>
						localIntegration.type === integration.type &&
						localIntegration.supportsQueryBlocks
				)
			)
			.map((integration: IIntegration) => ({
				integrationId: integration.id,
				integrationType: integration.type,
				value: integration.id,
				label: integration.name,
			})) || []
	);
};
